import React from 'react';
import {motion} from 'framer-motion';
import {FiStar} from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Testimonials=()=> {
  const reviews=[
    {
      name: "Sarah M.",
      text: "I was incredibly nervous to start driving,but the instructor was so patient and calming. The automatic car made everything so much easier to manage. Passed first time!",
    },
    {
      name: "James T.",
      text: "Highly recommend Crossroads Driving School! The lessons were well structured,and I always felt safe and supported. Great value for money and excellent teaching.",
    },
    {
      name: "Emma W.",
      text: "After failing previously with manual,switching to automatic with Crossroads was the best decision. Built my confidence back up and passed with only 2 minors.",
    },
    {
      name: "Chantelle",
      text: "Joes been so amazing to learn to drive with, I went into lessons super anxious and scared to start but he’s been so supportive and helpful along the way, would 1000 percent recommend him especially with those that are starting with low confidence😊🙏",
    },
    {
      name: "Craig",
      text: "Couldn’t reccomend Joe enough. Took my test last year under a different instructor and failed. Was low on confidence when I restarted but that soon went away and was reassured that I would be fine. Passed my test with no faults! Over the moon 🙂⭐️⭐️⭐️⭐️⭐️",
    },
    {
      name: "Danielle",
      text: "Joe has been the best instructor I could have ever wished for, after a rough start elsewhere Joe was patient, listened, clear with instructions and always believed in me! Joe built my confidence up week by week! Never thought i’d get there but today passed with ZERO faults!!! I’m so grateful would highly recommend!! Going to miss our lessons and weekly chats!",
    },
    {
      name: "Kim",
      text: "I couldn't have asked for a better instructor than Joe. I was very nervous when I first started learning, but Joe was brilliant at putting me at ease. He's always calm, patient, and incredibly friendly, which made every lesson enjoyable. He explained everything clearly, built my confidence step by step, and never made me feel rushed or under pressure. I would highly recommend Joe to anyone looking for an encouraging driving instructor. As a couple 🙏",
    },
  ];

  return (
    <section className="py-20 bg-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-brandOrange font-bold tracking-wider uppercase text-sm mb-2">Testimonials</h2>
          <h3 className="text-4xl font-extrabold text-royal">What Our Students Say</h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {reviews.map((review,index)=> (
            <motion.div
              key={review.name}
              initial={{opacity: 0,y: 20}}
              whileInView={{opacity: 1,y: 0}}
              viewport={{once: true}}
              transition={{duration: 0.5,delay: index * 0.1}}
              className="bg-white p-8 rounded-2xl shadow-lg relative"
            >
              <div className="flex text-yellow-400 mb-4">
                {[...Array(5)].map((_,i)=> (
                  <SafeIcon key={i} icon={FiStar} className="fill-current w-5 h-5" />
                ))}
              </div>
              <p className="text-gray-600 italic mb-6 leading-relaxed">"{review.text}"</p>
              <div className="font-bold text-royal">{review.name}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;